export default __webpack_public_path__ + "static/media/undraw_wallet_aym5.1e29d6e5.png";